<template>

  <div class="page">
    <div class="main">
      <!-- 頁面抬頭-->
      <section class="title-cover">
        <!-- 頁面標題-->
        <picture class="title-img"> <img src="../assets/awardPH/img/title.png"></picture>
      </section>
      <section class="awards awards-1st">
        <picture class="title-img"><img src="../assets/awardPH/img/no1.png"></picture>
        <ul class="awards-list">
          <li> <span class="name">Mr.Chen</span><span class="number">*******413</span></li>
        </ul>
        <picture class="awards-img"><img src="../assets/awardPH/img/no1-CAR.png"><img style="margin: -5% auto -6%;z-index: -1;"
            src="../assets/awardPH/img/bg-fifa.png"></picture>
      </section>
      <!-- 影片區-->
      <section class="video-cover">
        <picture class="title-img"><img src="../assets/awardPH/img/video-title.png"></picture>
        <div class="video-box"><iframe id="odysee-iframe" width="560" height="315"
          src="https://odysee.com/$/embed/特斯拉英文:6?r=wSexF3ohosVzk5VPEFEoJRbYmzEojK5n" allowfullscreen></iframe></div>
      </section>
      <section class="awards-cover">
        <!-- 2等獎-->
        <section class="awards awards-2st">
          <picture class="title-img"><img src="../assets/awardPH/img/no2.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">Rivera</span><span class="number">******542</span></li>
            <li> <span class="name">Villanueva</span><span class="number">*****eva</span></li>
            <li> <span class="name">Ramos</span><span class="number">***nny</span></li>
          </ul>
        </section>
        <!-- 3等獎-->
        <section class="awards awards-3st">
          <picture class="title-img"><img src="../assets/awardPH/img/no3.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">Baluyut</span><span class="number">***ary </span></li>
            <li> <span class="name">Torres</span><span class="number">****792</span></li>
            <li> <span class="name">Aquino</span><span class="number">****wbx</span></li>
            <li> <span class="name">Barrera</span><span class="number">******weg</span></li>
            <li> <span class="name">Santos</span><span class="number">*****nnn</span></li>
            <li> <span class="name">De Leon</span><span class="number">*****260</span></li>
          </ul>
        </section>
        <!-- 4等獎-->
        <section class="awards awards-4st">
          <picture class="title-img"><img src="../assets/awardPH/img/no4.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">Cruz</span><span class="number">*****485</span></li>
            <li> <span class="name">Castro</span><span class="number">*****zne</span></li>
            <li> <span class="name">Salazar</span><span class="number">******367</span></li>
            <li> <span class="name">Sotto</span><span class="number">****mrt</span></li>
            <li> <span class="name">De Mesa</span><span class="number">*****jex</span></li>
            <li> <span class="name">David </span><span class="number">*******766</span></li>
            <li> <span class="name">Dimalanta</span><span class="number">*******943</span></li>
            <li> <span class="name">Montemayor</span><span class="number">***616</span></li>
          </ul>
        </section>
        <!-- 5等獎-->
        <section class="awards awards-5st">
          <picture class="title-img"><img src="../assets/awardPH/img/no5.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">Valencia</span><span class="number">****ent</span></li>
            <li> <span class="name">Lumanug</span><span class="number">****376</span></li>
            <li> <span class="name">Isip</span><span class="number">*****cba</span></li>
            <li> <span class="name">Sanches</span><span class="number">****001</span></li>
            <li> <span class="name">Guanlao</span><span class="number">****510</span></li>
            <li> <span class="name">Layug</span><span class="number">********hee</span></li>
            <li> <span class="name">Reyes</span><span class="number">********894</span></li>
            <li> <span class="name">Garcia</span><span class="number">****468</span></li>
          </ul>
        </section>
      </section>
      <!-- 廠商-->
      <ul class="manufacturers-list">
        <li><img src="../assets/awardPH/img/logo-OB.png"></li>
        <li><img src="../assets/awardPH/img/logo-BWIN.png"></li>
        <li><img src="../assets/awardPH/img/logo-DBG.png"></li>
        <li><img src="../assets/awardPH/img/logo-QT.png"></li>
        <li><img src="../assets/awardPH/img/logo-GR.png"></li>
        <li><img src="../assets/awardPH/img/logo-BNG.png"></li>
        <li><img src="../assets/awardPH/img/logo-SA.png"></li>
      </ul>
    </div>
    <article class="btn-box"> <a class="btn btn-goHome" a href="https://www.ofa168.net"><img
          src="../assets/awardPH/img/icon-goHome.svg"></a></article>
  </div>
</template>

<script>
export default {

  data() {
    return {

    };
  },
}
</script>


<style scoped>
@import '../assets/awardPH/css/style.css';
</style>



// WEBPACK FOOTER //
// src/components/award18.vue